import React, { useState } from 'react';
import style from './basicAccordion.module.scss';

interface IBasicAccordionProps {
  summaryData?: React.ReactNode;
  detailData?: React.ReactNode;
  showDetailText: string;
  showSummaryText: string;
  showExpandAction?: boolean;
}

const BasicAccordion = ({
  summaryData,
  detailData,
  showDetailText,
  showSummaryText,
  showExpandAction = true,
}: IBasicAccordionProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <div
      data-testid='basic-accordion'
      className={style.accordion}
      onClick={() => setIsAccordionOpen(!isAccordionOpen)}
      onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
    >
      <div
        className={`basic-accordion ${style.accordionContent} ${isAccordionOpen ? style.detailContent : style.summaryContent}`}
      >
        {isAccordionOpen ? detailData : (summaryData ?? '')}
      </div>
      {showExpandAction && (
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {isAccordionOpen ? (
              <>
                {showSummaryText}
                <i className={`fas fa-chevron-up fa-sm ${style.iconOpen}`} />
              </>
            ) : (
              <>
                {showDetailText}
                <i className={`fas fa-chevron-up fa-sm ${style.iconClosed} `} />
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
};

export default BasicAccordion;
